import { render, staticRenderFns } from "./root-app.component.vue?vue&type=template&id=7b14f867&"
import script from "./root-app.component.vue?vue&type=script&lang=ts&"
export * from "./root-app.component.vue?vue&type=script&lang=ts&"
import style0 from "./root-app.component.vue?vue&type=style&index=0&id=7b14f867&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports